export * from './Page_SmartOnFhir.js';
//# sourceMappingURL=index.js.map